import React, { useState, useContext ,useEffect} from 'react';
import { Link, useNavigate,useParams  } from 'react-router-dom';
import Logo from '../../assets/logo.png'; 
import '../../styles/external_receipt.css';
import * as Constants from '../../constants';
import BackLoader from '../../components/backloader';
import JisButton from '../../components/controls/jisButton';
function DocReceipt() {
 const [receipt, setReceipt]=useState(null)
 const {refid} = useParams();
 const [loading, setLoading]=useState(false);
    useEffect(() => {
        onLoad();
  }, []);

  const onLoad= async()=>{
              //for account registration
    try {

        setLoading(true);
        const resp = await fetch(`${Constants.apiUrl}/payment/external-receipt/${refid}`, { 
            method: 'GET',  
            headers: {  'Content-Type': 'application/json' }
            });  
        const data = await resp.json();
        setLoading(false);

        setReceipt(data)

        } catch (error) {
        setLoading(false);
        console.error(error);   
        }
          }

  return (
    <div>
     <div className="newreceipt">
        <div className="header">
          <img src={Logo} alt="Lagos Logo" />
          <div className="title">Lagos State Judiciary Information System</div>
          <a>Payment Receipt</a>
        </div>
    
        <div className="section row">
          <div className="col"><strong>Suit Number:</strong> <span>{receipt?.casenumber}</span> </div>
          <div className="col"><strong>Amount (₦):</strong><span>{receipt?.amount}</span> </div>
          <div className="col"><strong>Paid On:</strong><span>{receipt?.paidon}</span> </div>

          <div className="col"><strong>PayerID:</strong><span>{receipt?.payerid}</span> </div>
          <div className="col"><strong>Payment By:</strong><span>{receipt?.payby}</span> </div>
          <div className="col"><strong>Transaction Number:</strong><span>{receipt?.transid}</span> </div>

          {receipt?.webguid!=null && <div className="col"><strong>Bill Reference:</strong>{receipt?.webguid} </div>}   
          <div className="col"><strong>Revenue Code:</strong> 51102</div>
          <div className="col"><strong>Payment Address:</strong>High Court of Lagos State</div>
          
        </div>
    
        <table>
          <thead>
             
            <tr >
              <th>Sl.No</th>
              <th>Description</th>
              <th>Qty</th>
              <th>Fee</th>
              <th>Cost</th>
            </tr>
          </thead>
          <tbody>
             {receipt?.lines?.map((opt, index) => (
            <tr>
              <td>{index+1}</td>
              <td>{opt.title}</td>
              <td>{opt.qty}</td>
              <td>{opt.perItem}</td>
              <td>{opt.total}</td>
            </tr>
        ))}
          </tbody>
        </table>
    
        <div className="totals">
          Total: ₦{receipt?.amount}<br />
          Service Fee: ₦0<br />
          Convenience Fee: ₦0<br />
          <strong>Grand Total: ₦{receipt?.amount}</strong>
        </div>
      </div>
      <div className='no-print' style={{textAlign:'right'}}><JisButton onClick={()=>window.print()}>Print</JisButton></div>
      <BackLoader open={loading} />
    </div>
  );
}

export default DocReceipt;